import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", company: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data.user);
      toast.success("¡Cuenta creada!");
      navigate("/panel");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="overline text-brand mb-2">Nuevo cliente</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-8">CREAR CUENTA</h1>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Nombre completo</Label><Input required data-testid="register-name" value={form.name} onChange={set("name")} /></div>
          <div><Label>Correo</Label><Input type="email" required data-testid="register-email" value={form.email} onChange={set("email")} /></div>
          <div><Label>Contraseña</Label><Input type="password" required minLength={6} data-testid="register-password" value={form.password} onChange={set("password")} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Teléfono</Label><Input data-testid="register-phone" value={form.phone} onChange={set("phone")} /></div>
            <div><Label>Empresa</Label><Input data-testid="register-company" value={form.company} onChange={set("company")} /></div>
          </div>
          <button type="submit" disabled={loading} data-testid="register-submit"
            className="w-full h-11 bg-brand text-black font-semibold hover:bg-brand-hover transition-colors disabled:opacity-60">
            {loading ? "Creando..." : "Crear cuenta"}
          </button>
        </form>
        <p className="text-sm text-muted-foreground text-center mt-6">
          ¿Ya tienes cuenta? <Link to="/login" className="text-brand font-semibold">Ingresa</Link>
        </p>
      </div>
    </div>
  );
}
